module.exports = __webpack_public_path__ + "static/media/gb-nir.43b61fea.svg";